module.exports = __webpack_public_path__ + "static/img/serverNew3.281ad64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serve/serverNew3.jpg
// module id = 0ock
// module chunks = 0